export const BETA_CHANNEL_KEYS = ['tiktok', 'voice', 'whatsapp_call'];

export const isBetaChannel = channelKey =>
  BETA_CHANNEL_KEYS.includes(channelKey);

const hasFbConfigured = () => window.chatwootConfig?.fbAppId;
const hasInstagramConfigured = () => window.chatwootConfig?.instagramAppId;
const hasTiktokConfigured = () => window.chatwootConfig?.tiktokAppId;
const hasWhatsappConfigured = () =>
  !!window.chatwootConfig?.whatsappAppId &&
  window.chatwootConfig.whatsappAppId !== 'none';

export const isChannelActive = (channelKey, enabledFeatures) => {
  if (!enabledFeatures || Object.keys(enabledFeatures).length === 0) {
    return false;
  }

  switch (channelKey) {
    case 'website':
      return enabledFeatures.channel_website;
    case 'facebook':
      return enabledFeatures.channel_facebook && hasFbConfigured();
    case 'email':
      return enabledFeatures.channel_email;
    case 'instagram':
      return enabledFeatures.channel_instagram && hasInstagramConfigured();
    case 'tiktok':
      return enabledFeatures.channel_tiktok && hasTiktokConfigured();
    case 'mercadolibre':
      return enabledFeatures.channel_mercadolibre;
    case 'voice':
      return enabledFeatures.channel_voice;
    case 'whatsapp_call':
      return enabledFeatures.channel_whatsapp_call && hasWhatsappConfigured();
    case 'api':
      return enabledFeatures.channel_api;
    case 'sms':
      return enabledFeatures.channel_sms;
    case 'line':
      return enabledFeatures.channel_line;
    case 'telegram':
      return enabledFeatures.channel_telegram;
    default:
      return ['twilio', 'whatsapp'].includes(channelKey);
  }
};

export const isChannelVisible = (channelKey, enabledFeatures) => {
  if (isBetaChannel(channelKey)) {
    return isChannelActive(channelKey, enabledFeatures);
  }

  return true;
};
